module.exports = __webpack_public_path__ + "static/media/this-is-sam-francis.c56fbf21.jpg";